<template>
  <v-list-item :key="item.title" link :to="item.href">
    <v-list-item-icon>
      <div class="icon-container">
        <FIcon :name="item.icon" class="img-icon" />
      </div>
    </v-list-item-icon>

    <v-list-item-content>
      <v-list-item-title>
        {{ $t(`${item.title}`) }}
      </v-list-item-title>
    </v-list-item-content>
    <BadgeNotificationChat v-if="item.badgeId === NAV_BADGE.CHART_NOTIFICATION_BADGE && !isActive" />
  </v-list-item>
</template>

<script>
import Vue from "vue";
import BadgeNotificationChat from "../badge/notifications/chat/index";
import { NAV_BADGE } from "@/enums/apps.enum";

const LinkItem = Vue.extend({
  name: "LinkItem",

  components: {
    BadgeNotificationChat,
  },

  data: () => ({
    NAV_BADGE,
  }),

  props: {
    item: {
      required: true,
      default: null,
      type: Object,
    },
  },

  computed: {
    /**
     * Get Is Active Nav
     * @return {boolean}
     */
    isActive() {
      return this.$route.path.search(this.item.href) !== -1;
    },
  },
});
export default LinkItem;
</script>
